import { EVENTS, EventModels } from '../Events'

export default class GoogleAnalytics {
  constructor (ReactGA, hostname, userData) {
    this.name = 'Google Analytics'
    this.user = userData
    this.ReactGA = ReactGA
    this.ReactGA.ga('require', 'ecommerce')
  }

  handleEvent (type, data) {
    let eventData

    if (type === EVENTS.PAGE_VIEW) {
      const pageViewData = Object.assign(EventModels[type], data)
      // console.log('sending page view: ' + this.user.industry);
      this.ReactGA.ga('set', 'dimension1', this.user.industry)
      this.ReactGA.ga('send', 'pageview', pageViewData.path)
    } else if (type === EVENTS.PLAN_SUBSCRIPTION) {
      const ecommerceData = Object.assign(EventModels[type].fields, data)
      this.ReactGA.ga('set', 'dimension1', this.user.industry)

      this.ReactGA.plugin.execute('ecommerce', 'addItem', ecommerceData)
      // console.log(ecommerceData)
      this.ReactGA.plugin.execute('ecommerce', 'send')
    } else if (EVENTS.hasOwnProperty(type)) {
      eventData = Object.assign(EventModels[type].fields, data)
      this.ReactGA.ga('set', 'dimension1', this.user.industry)

      this.ReactGA.event(eventData)
    } else {
      console.log(`Google Analytics Event ${type} not specified for GA`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/analytics/Vendors/GoogleAnalytics.js